import type { StatisticsInfo, StatisticsInfoDTO, StatisticsSubInfo, StatisticsSubInfoDTO } from '../model/types'

export const mapStatisticsFromDTO = ({
    average_views,
    bought_posts,
    involvement_er,
    planned_posts,
    posts_count,
    published_posts,
    sold_posts,
    top_posts
}: StatisticsInfoDTO): StatisticsInfo => ({
    postsStatistics: {
        soldPosts: sold_posts,
        boughtPosts: bought_posts,
        plannedPosts: planned_posts,
        publishedPosts: published_posts,
        averageViews: average_views,
        involvementEr: involvement_er,
        postsCount: posts_count
    },
    topPosts: top_posts.map((i) => ({
        date: i.date,
        reactions: i.reactions,
        views: i.views,
        telegramId: i.telegram_id,
        telegramUrl: i.telegram_url
    }))
})

export const mapStatisticsSubFromDTO = ({
    subscribers_dynamics,
    subscribers_left_dynamics
}: StatisticsSubInfoDTO): StatisticsSubInfo => ({
    subscribersDynamics: subscribers_dynamics.map((i) => ({
        createdAt: i.created_at,
        membersCount: i.members_count
    })),
    subscribersLeftDynamics: subscribers_left_dynamics.map((i) => ({
        createdAt: i.bucket_start,
        membersCount: i.count
    }))
})
